"use strict";

var _toConsumableArray = require("/root/builder-configuration/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentUserObj = exports.currentSettingObj = exports.currentTenantObj = exports.currentSubTenantObj = exports.EQUALS_OR_IGNORE = exports.CURRENTS = exports.DateRangeConstant = exports.DateConstant = exports.DateTimeUnit = exports.CURRENT_YEAR = exports.CURRENT_MONTH = exports.YEAR = exports.MONTH = exports.WEEK = exports.DAY = exports.HOUR = exports.CURRENT_DATE_TIME = exports.CURRENT_DATE = exports.CURRENT_TIME = exports.CURRENT_SUB_TENANT = exports.CURRENT_SETTINGS = exports.CURRENT_TENANT = exports.CURRENT_USER = exports.IS_BOOLEAN_FALSE = exports.IS_BOOLEAN_TRUE = exports.NOT_EQUAL = exports.BETWEEN = exports.GREATER_THAN_EQUALS_TO = exports.LESS_THAN_EQUALS_TO = exports.GREATER_THAN = exports.LESS_THAN = exports.NOT_IN_LIST = exports.IN_LIST = exports.LIKE = exports.IS_NULL = exports.IS_NOT_NULL = exports.EQUALS = void 0;
exports.EQUALS = "EQUALS";
exports.IS_NOT_NULL = "IS_NOT_NULL";
exports.IS_NULL = "IS_NULL";
exports.LIKE = "LIKE";
exports.IN_LIST = "IN_LIST";
exports.NOT_IN_LIST = "NOT_IN_LIST";
exports.LESS_THAN = "LESS_THAN";
exports.GREATER_THAN = "GREATER_THAN";
exports.LESS_THAN_EQUALS_TO = "LESS_THAN_EQUALS_TO";
exports.GREATER_THAN_EQUALS_TO = "GREATER_THAN_EQUALS_TO";
exports.BETWEEN = "BETWEEN";
exports.NOT_EQUAL = "NOT_EQUAL";
exports.IS_BOOLEAN_TRUE = "IS_BOOLEAN_TRUE"; // Used in Visibility Panel
exports.IS_BOOLEAN_FALSE = "IS_BOOLEAN_FALSE"; // Used in Visibility Panel
exports.CURRENT_USER = "CURRENT_USER";
exports.CURRENT_TENANT = "CURRENT_TENANT";
exports.CURRENT_SETTINGS = "CURRENT_SETTINGS";
exports.CURRENT_SUB_TENANT = "CURRENT_SUB_TENANT";
exports.CURRENT_TIME = "CURRENT_TIME";
exports.CURRENT_DATE = "CURRENT_DATE";
exports.CURRENT_DATE_TIME = "CURRENT_DATE_TIME";
exports.HOUR = "HOUR";
exports.DAY = "DAY";
exports.WEEK = "WEEK";
exports.MONTH = "MONTH";
exports.YEAR = "YEAR";
exports.CURRENT_MONTH = "CURRENT_MONTH";
exports.CURRENT_YEAR = "CURRENT_YEAR";
exports.DateTimeUnit = [exports.HOUR, exports.DAY, exports.WEEK, exports.MONTH, exports.YEAR];
exports.DateConstant = [exports.CURRENT_DATE, exports.CURRENT_TIME, exports.CURRENT_DATE_TIME].concat(_toConsumableArray(exports.DateTimeUnit));
exports.DateRangeConstant = [exports.CURRENT_MONTH, exports.CURRENT_YEAR];
exports.CURRENTS = [exports.CURRENT_USER, exports.CURRENT_TENANT, exports.CURRENT_SETTINGS, exports.CURRENT_SUB_TENANT];
exports.EQUALS_OR_IGNORE = "EQUALS_OR_IGNORE";
exports.currentSubTenantObj = {
  name: "Current LoggedIn Sub Tenant",
  value: exports.CURRENT_SUB_TENANT
};
exports.currentTenantObj = {
  name: "Current LoggedIn User Tenant",
  value: "CURRENT_TENANT"
};
exports.currentSettingObj = {
  name: "Current LoggedIn User Settings",
  value: exports.CURRENT_SETTINGS
};
exports.currentUserObj = {
  name: "Current LoggedIn User",
  value: exports.CURRENT_USER
};